var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-image-slide"},[(!_vm.hasRequestFailed)?_c('div',{staticClass:"columns"},[(_vm.imageLoaded)?_c('div',{staticClass:"full-size-image",style:({
        backgroundImage: `url('${_vm.image}')`,
        backgroundSize: `${_vm.slide.image.backgroundSize}`})}):_vm._e(),(_vm.slide.narrative && _vm.slide.narrative.text)?_c('div',{staticClass:"narrative",style:(_vm.cssVars),domProps:{"innerHTML":_vm._s(_vm.slide.narrative.text)}}):_vm._e()]):_c('placeholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }